import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useNavigate, Link } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import { IoMdArrowBack } from "react-icons/io";
import { rectSortingStrategy } from '@dnd-kit/sortable';
import {
    DndContext,
    closestCenter
} from '@dnd-kit/core';

import {
    SortableContext,
    useSortable,
    arrayMove
} from '@dnd-kit/sortable';

import { CSS } from '@dnd-kit/utilities';

import Sidebar from '../components/Sidebar';
import toast, { Toaster } from 'react-hot-toast';
import { API } from '../../api/Api';


const SortableColorCard = ({ color, IMAGE_BASE_URL }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id: color.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        width: '200px'   // 👈 card width fixed
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            className="bg-white border rounded-md p-1 shadow cursor-move"
        >
            <img
                src={`${IMAGE_BASE_URL}${color.thumbnail_image}`}
                alt={color.name}
                className="w-[200px] h-[70px] object-cover rounded"
            />

            <p className="mt-1 text-[12px] text-center font-medium truncate">
                {color.name}
            </p>
        </div>
    );
};



const CollectionColors = () => {
    const { state } = useLocation();
    const { collectionId } = useParams();
    const navigate = useNavigate();
    const IMAGE_BASE_URL = process.env.REACT_APP_VISUAL_APP_IMAGE_BASE_URL;
    const token = localStorage.getItem('token');
    const [loading, setLoading] = useState(false);
    const [colors, setColors] = useState([]);
    const [saving, setSaving] = useState(false);
    const [isOrderChanged, setIsOrderChanged] = useState(false);
    const [sortType, setSortType] = useState('default');
    const [initialColors, setInitialColors] = useState([]);
    useEffect(() => {
        setLoading(true);

        if (state?.colors?.length > 0) {

            const orderedColors = [...state.colors].sort(
                (a, b) => a.sort_order - b.sort_order
            );

            setColors(orderedColors);
            setInitialColors(orderedColors);
            setIsOrderChanged(false);
        }

        setLoading(false);
    }, [state]);

    const handleDragStart = () => {

        setSortType(sortType);

    };


    const handleSortChange = (e) => {
        const value = e.target.value;
        setSortType(value);

        let sorted = [...colors];

        if (value === 'az') {
            sorted.sort((a, b) => a.name.localeCompare(b.name));
        } else if (value === 'za') {
            sorted.sort((a, b) => b.name.localeCompare(a.name));
        }

        setColors(sorted);        // 🔥 IMPORTANT
        setIsOrderChanged(true);
    };

    /* ---------- Drag End ---------- */
    const handleDragEnd = ({ active, over }) => {
        if (!over || active.id === over.id) return;

        const oldIndex = colors.findIndex(c => c.id === active.id);
        const newIndex = colors.findIndex(c => c.id === over.id);

        if (oldIndex === -1 || newIndex === -1) return;

        setColors(arrayMove(colors, oldIndex, newIndex));
        setIsOrderChanged(true);
    };





    /* ---------- Save Order ---------- */
    const handleSaveOrder = async () => {
        const url = `${process.env.REACT_APP_API_URL}/visualizer/updatecolororder`;


        const currentOrder = colors.map(c => c.id).join(',');

        try {
            setSaving(true);
            const response = await API(url, { ids: currentOrder }, token);

            if (response?.Result === 1) {
                toast.success('Color order updated successfully');
                setIsOrderChanged(false);
                //setSortType('default'); // reset sort if needed
            } else {
                toast.error('Failed to update color order');
            }
        } catch (error) {
            toast.error('Something went wrong');
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            {loading
                && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-neutral-900/80">
                        <BeatLoader size={20} />
                    </div>
                )}



            <Toaster position="top-center" />

            <div className="flex h-screen fixed w-full">

                <div className="md:w-64 w-16 bg-black transition-all">
                    <Sidebar />
                </div>

                <div className="flex flex-col flex-1 min-h-full">
                    <div className="bg-gray-100 flex flex-col flex-1 overflow-y-auto p-6">
                        <div className="bg-white rounded-2xl w-full flex flex-col min-h-full">
                            <div className="flex justify-between items-center px-6 pt-4">
                                <div >
                                    <p className="text-teal-500 text-xl font-semibold flex items-center gap-3">

                                    </p>
                                    <p className="text-gray-600 mb-4">
                                        <span className="text-teal-500">
                                            <Link to="/admin/collections" className="hover:text-teal-600 transition">Collections</Link>
                                        </span>
                                        <span className="text-gray-500">   – {state?.collectionName}</span>
                                    </p>

                                </div>

                                <div className='flex justify-end'><select
                                    value={sortType}
                                    onChange={handleSortChange}
                                    className="border rounded px-3 py-1 text-sm"
                                >
                                    <option value="default">Select Order</option>
                                    <option value="az">Order By(A-Z)</option>
                                    <option value="za">Order BY(Z–A)</option>
                                </select></div>



                            </div>
                            <hr className="border-gray-200 mb-4" />
                            <DndContext
                                collisionDetection={closestCenter}
                                onDragStart={handleDragStart}
                                onDragEnd={handleDragEnd}
                            >
                                <SortableContext items={colors.map(c => c.id)} strategy={rectSortingStrategy} >
                                    <div
                                        className="grid gap-4 px-6"
                                        style={{
                                            gridTemplateColumns: 'repeat(auto-fill, 200px)',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        {colors.map((color) => (
                                            <SortableColorCard
                                                key={color.id}
                                                color={color}
                                                IMAGE_BASE_URL={IMAGE_BASE_URL}
                                            />
                                        ))}
                                    </div>
                                </SortableContext>


                            </DndContext>

                            {/* Save Button */}
                            <div className="fixed bottom-0 left-0 md:left-64 right-0 bg-white border-t shadow-lg px-6 py-4 flex justify-end z-40">
                                <button
                                    onClick={handleSaveOrder}
                                    disabled={!isOrderChanged || saving}
                                    className="bg-gradient-to-r from-teal-400 to-teal-500 text-white px-8 py-2 rounded shadow 
        hover:from-teal-500 hover:to-teal-600 
        disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    {saving ? 'Saving...' : 'Save Order'}
                                </button>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CollectionColors;
